import type { ReactNode } from 'react';

interface SettingsSectionProps {
    title: string;
    description?: string;
    children: ReactNode;
    footer?: ReactNode;
}

export default function SettingsSection({ title, description, children, footer }: SettingsSectionProps) {
    return (
        <section className="mb-6 last:mb-0">
            <div className="mb-3">
                <h3 className="text-sm font-semibold text-[#1e293b]">{title}</h3>
                {description && (
                    <p className="text-xs text-[#64748b] mt-0.5">{description}</p>
                )}
            </div>
            <div className="rounded-xl border border-[#e2e8f0] bg-white divide-y divide-[#f1f5f9]">
                {children}
            </div>
            {footer && <div className="mt-3 flex justify-end">{footer}</div>}
        </section>
    );
}
